import {
  collectFlowEffectsFromTemplate,
  normalizeGuideTemplateWithFlow,
  buildFlowFromQuestions,
  getCurrentQuestion,
  getFlowNode,
  getNextNodeId,
  getNextQuestionNodeId,
  getQuestionNodes,
  getStartNodeId,
  getVisitedFlowNodes,
  getVisitedQuestionNodes,
  normalizeFlow,
  normalizeOptions,
  questionsFromFlow,
  resolveGuideQuestionNavigation,
} from "../../../utils/guideFlow/guideFlowCore";

export {
  buildFlowFromQuestions,
  getCurrentQuestion,
  getFlowNode,
  getNextNodeId,
  getNextQuestionNodeId,
  getQuestionNodes,
  getStartNodeId,
  getVisitedFlowNodes,
  getVisitedQuestionNodes,
  normalizeFlow,
  normalizeOptions,
  questionsFromFlow,
  resolveGuideQuestionNavigation,
};

export function normalizeReportGuideTemplate(template) {
  return normalizeGuideTemplateWithFlow(template);
}

function mergeReportGuideEffect(effects, effect) {
  const data = effect || {};
  effects.tag_ids = [...effects.tag_ids, ...(data.tag_ids || [])];

  [
    "priority",
    "title_suffix",
    "report_text",
    "internal_report_text",
    "must_be_rectified",
    "complaint",
    "checklist_type_id",
    "create_checklist",
    "case_followup_title",
    "case_followup_text",
    "create_sequel",
    "sequel_description",
    "sequel_internal_description",
    "sequel_checklist_type_id",
    "sequel_create_checklist",
    "sequel_has_agreement",
    "sequel_use_current_agreement_time",
    "sequel_agreement_date",
    "sequel_agreement_time",
  ].forEach((key) => {
    if (data[key] === undefined || data[key] === null || data[key] === "") return;
    if (["report_text", "internal_report_text", "sequel_description", "sequel_internal_description"].includes(key)) {
      effects[key] = [...(effects[key] || []), data[key]];
    } else {
      effects[key] = data[key];
    }
  });
}

export function collectFlowEffects(template, answers) {
  return collectFlowEffectsFromTemplate(template, answers, mergeReportGuideEffect);
}
